import {StatusCallStatusEnum} from '../../../model/status-calls/status-call-status.enum';

export const statusCallColors: Record<StatusCallStatusEnum, string> = {
  SCHEDULED: '#4e73df',
  COMPLETED: '#1cc88a',
  CANCELLED: '#9e9e9e',
};

export const hoursForDuration = (durationMinutes: number): number =>
  Math.round((durationMinutes / 60) * 10) / 10;

export const isValidSlotMinute = (date: Date): boolean =>
  date.getMinutes() % 30 === 0 && date.getSeconds() === 0;

export const formatDateTimeLocal = (iso: string): string => {
  const d = new Date(iso);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const toIsoLocal = (datePart: string, timePart: string): string =>
  `${datePart}T${timePart}:00`;

export const formatDuration = (minutes: number): string =>
  minutes === 60 ? '1h' : `${minutes}min`;
